import { combineReducers } from '@reduxjs/toolkit';
import exchangeReducer from '../exchange/store';
import currenciesReducer from '../currencies/store';
import realtimeReducer from '../realtime/store';

const commonReducer = combineReducers({
  exchange: exchangeReducer,
  currencies: currenciesReducer,
  realtime: realtimeReducer,
});

export type CommonState = ReturnType<typeof commonReducer>;

export default commonReducer;
